import { useState } from "react"
import { isObject } from "utils/helpers"

export default () => {
  const [status, setStatus] = useState({})

  const setSaving = () => setStatus({ text: "Saving...", icon: "spinner" })

  const setSuccess = () => {
    setStatus({ text: "Saved!", icon: "general#check", type: "success" })
    setTimeout(() => setStatus({}), 3000)
  }

  const setError = error => {
    setStatus({
      text: errorText(error) || "Changes not saved",
      icon: "general#exclamation-triangle",
      type: "error"
    })
  }

  const errorText = error => {
    if (isObject(error)) {
      return `${error.meta.resource} "${error.source.parameter}" ${error.detail}`
    } else {
      return error
    }
  }

  return { get: () => status, setSaving, setSuccess, setError }
}
